import axios from "@/plugins/axios";

export const state = () => ({
  ledger_types: {},
});

export const mutations = {
  SET_LEDGER_TYPES(state, payload) {
    state.ledger_types = payload;
  },
};

export const actions = {
  async fetchLedgerTypes({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("ledger-types")
        .then((res) => {
          if (res.data.data) {
            commit("SET_LEDGER_TYPES", res.data.data);
            resolve(res.data.data);
          } else {
            commit("SET_LEDGER_TYPES", []);
            resolve([]);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async createSupplier({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post("pos/suppliers", payload)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
